// @flow
import styled from 'styled-components';

export const ApprovalSpan = styled.span`
	font-weight: bold;
	font-size: 14px;
`;

export default ApprovalSpan;


// WEBPACK FOOTER //
// ./src/components/Trades/ApprovalSpan.js